export class Page {
    totalElements: number = 0;
    totalPages: number = 0;
    size: number = 0;
    pageNumber: number = 0;
}
